if (!customElements.get('product-tab')) {
  customElements.define(
    'product-tab',
    class ProductTab extends HTMLElement {
      connectedCallback() {
        this.querySelectorAll('[data-accordion-toggle]').forEach((toggle) => {
          toggle.addEventListener('click', () => {
            const panel = this.querySelector(`#${toggle.dataset.accordionToggle}`);
            if (!panel) return;
            const oeffnen = panel.hidden;
            panel.hidden = !oeffnen;
            toggle.setAttribute('aria-expanded', String(oeffnen));
          });
        });
      }
    }
  );
}
